import axios from 'axios';

const matrimonyBaseUrl = (process.env.REACT_APP_API_URL || 'https://api.indianyadavs.com').replace(/\/$/, '');
const campaignBaseUrl = (process.env.REACT_APP_CAMPAIGN_API_URL || 'https://capi.indianyadavs.com').replace(/\/$/, '');

export const publicAxios = axios.create({
    baseURL: matrimonyBaseUrl,
    headers: {
        'Content-Type': 'application/json',
    },
});

export const authorizedAxios = axios.create({
    baseURL: matrimonyBaseUrl,
    headers: {
        'Content-Type': 'application/json'
    },
});

export const authorizedMultpartAxios = axios.create({
    baseURL: matrimonyBaseUrl,
    headers: { "Content-Type": "multipart/form-data" },
});

export const campaignAuthorizedAxios = axios.create({
    baseURL: campaignBaseUrl,
    headers: {
        'Content-Type': 'application/json'
    },
});

authorizedMultpartAxios.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken)
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

campaignAuthorizedAxios.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken)
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

authorizedAxios.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken)
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
